import React, { useEffect } from "react";
import { dataCurta } from "../data/novidades";

// Modal de uma novidade, com setas para as outras (carrossel). Quem decide o que conta como "visto" é quem abre:
// aberto sozinho na entrada NÃO marca; aberto pelo sino/página ou clicando no botão de ação, marca.
export default function NovidadesModal({ lista, indice, onIndice, onFechar, onAcao }) {
  useEffect(() => {
    const esc = (ev) => { if (ev.key === "Escape") onFechar(); };
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [onFechar]);

  const n = lista[indice];
  if (!n) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/55 p-4"
      onMouseDown={(ev) => { if (ev.target === ev.currentTarget) onFechar(); }}>
      <div className="relative w-full max-w-md rounded-2xl bg-white p-6 text-gray-800 shadow-2xl" role="dialog" aria-modal="true" aria-label={n.titulo}>
        <button onClick={onFechar} className="absolute right-3 top-2 text-2xl text-gray-400 hover:text-gray-700" aria-label="Fechar">×</button>
        <div className="mb-4 flex h-32 items-center justify-center rounded-xl bg-orange-50 text-6xl">{n.ic}</div>
        <p className="text-xs font-bold tracking-wide text-orange-500">NOVIDADE · {dataCurta(n.data)}</p>
        <h2 className="mt-1 mb-2 text-xl font-bold text-primary">{n.titulo}</h2>
        <p className="mb-5 text-[15px] leading-relaxed">{n.texto}</p>
        {lista.length > 1 && (
          <div className="mb-4 flex items-center justify-between text-sm">
            <button onClick={() => onIndice(indice - 1)} disabled={indice === 0}
              className="font-semibold text-primary disabled:text-gray-300">‹ anterior</button>
            <div className="flex gap-1.5">
              {lista.map((x, k) => <span key={x.id} className={`h-2 w-2 rounded-full ${k === indice ? "bg-primary" : "bg-gray-300"}`} />)}
            </div>
            <button onClick={() => onIndice(indice + 1)} disabled={indice === lista.length - 1}
              className="font-semibold text-primary disabled:text-gray-300">próxima ›</button>
          </div>
        )}
        <button onClick={() => onAcao(n)} className="w-full rounded-xl bg-orange-500 py-3 text-base font-bold text-white hover:bg-orange-600">
          {n.cta}
        </button>
      </div>
    </div>
  );
}
